import React from "react";
import "./Detailed_Timeline.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const DetailedTimeline = () => {
  const timelineData = [
    {
      step: "01",
      title: "Week 1: Initial Assessment",
      description:
        "You meet with our team, discuss your aspirations, and submit initial documents. We review your qualifications against available opportunities.",
      duration: "3-5 days",
    },
    {
      step: "02",
      title: "Week 2-3: Skill Verification",
      description:
        "Interviews, language tests, and technical assessments. Document verification and background checks completed.",
      duration: "7-10 days",
    },
    {
      step: "03",
      title: "Week 4-6: Job Placement",
      description:
        "Matched with employers, interviews conducted, and job offer received with contract details and salary package.",
      duration: "14-21 days",
    },
    {
      step: "04",
      title: "Week 7-12: Visa & Preparation",
      description:
        "Visa application submitted, medical tests, pre-departure training, and travel arrangements completed.",
      duration: "30-45 days",
    },
    {
      step: "05",
      title: "Final Stage: Departure & Placement",
      description:
        "Visa approved, final briefing, departure, and successful placement at employer location with ongoing support.",
      duration: "Variable",
    },
  ];

  return (
    <section className="detailed-timeline">
      <div className="container">
        <CommonHeading
          badge="our process"
          title="Detailed Timeline"
          description="  A clear step-by-step journey from initial assessment to successful
            placement."
        />

        <div className="timeline-wrapper">
          <div className="timeline-line"></div>

          {timelineData.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-number">{item.step}</div>

              <div className="timeline-card">
                <div className="card-top">
                  <div className="card-title">
                    <h3>{item.title}</h3>
                  </div>

                  <span className="duration-badge">{item.duration}</span>
                </div>

                <p>{item.description}</p>

                <div className="progress-wrapper">
                  <span>Timeline</span>

                  <div className="progress-bar">
                    <span
                      style={{
                        width: `${((index + 1) / timelineData.length) * 100}%`,
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DetailedTimeline;
